import React from "react";
import ThumbsUp from "../../assets/order/thumb.png";
import ThumbsDown from "../../assets/order/ThumbDown.png";

import { IoCloseOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";

const SuccessPoP = ({
  onClose,
  message,
  status,
  subMessage,
  redirectPath = "/",
  button,
  buttonText,
  setPopup,
  Trybutton,
  showCloseIcon,
}) => {
  const navigate = useNavigate();

  const handleContinueShopping = () => {
    navigate(redirectPath);
  };

  // const handleTryAgain = () => {
  //   navigate(redirectPath);
  // };

  return (
    //default for order success placement
    <div className="mx-auto flex w-full max-w-sm flex-col items-center justify-center gap-4 rounded-lg border-2 bg-white p-10">
      {/* Close Icon */}
      {showCloseIcon && (
        <div className="flex w-full justify-end">
          <IoCloseOutline
            className="cursor-pointer text-2xl text-gray-500 hover:text-gray-800"
            onClick={onClose}
          />
        </div>
      )}
      {/* Confirmation Image */}
      <div className="w-36">
        {status ? (
          <img src={ThumbsUp} alt="Thumb image" />
        ) : (
          <img src={ThumbsDown} alt="Thumb image" />
        )}
      </div>

      {/* Confirmation Messages */}
      <div className="space-y-2 text-center">
        <h2 className="text-lg font-medium">
          {message || "Order is Confirmed"}
        </h2>
        <h3 className={`${status ? "text-green-500" : "text-red-500"} text-sm`}>
          {subMessage || "Waiting for Seller Approval"}
        </h3>
      </div>

      {/* Continue Shopping Button */}
      {button === true && (
        <div>
          <button
            className="w-60 rounded-lg bg-green-500 py-3 text-white hover:bg-green-600 active:bg-green-700"
            onClick={handleContinueShopping}
          >
            {buttonText ? buttonText : "Continue Shopping"}
          </button>
        </div>
      )}
      {/* try again button */}
      {Trybutton === true && (
        <div>
          <button
            className="w-60 rounded-lg bg-green-500 py-3 text-white hover:bg-green-600 active:bg-green-700"
            onClick={onClose}
          >
            {buttonText ? buttonText : "Try Again"}
          </button>
        </div>
      )}
    </div>
  );
};

export default SuccessPoP;
